/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_OtherInputs */



/**
* | output |
* | --- |
* | "Other..." |
*
* @param {Input_Position_X_OtherInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_other = /** @type {((inputs?: Input_Position_X_OtherInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_OtherInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Autre...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Andere...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Altro...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Другой...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Otro...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("其他...")
	if (locale === "ja") return /** @type {LocalizedString} */ ("他の...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अन्य...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Outro...")
	return /** @type {LocalizedString} */ ("Other...")
});